import React, {Component} from 'react';
import { BASE_URL } from '../../constants/app_routes';
import {Button, Form, Input, Grid, Header, Icon, Image, Modal, Popup, Segment,Divider, Message,List} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import Loader from "../universal/loader";
import {getPVReportById} from "../../data/property_visit_api"
import { REPORT_ACTIONS_API_URL } from '../../constants/api_routes';

const uuidv1 = require('uuid/v1');

class PVChecklist extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reportDetails:undefined,
            validChecks:[]
        }
    }
    componentDidMount() {
        getPVReportById( this.props.reportId).then((response) =>{
            this.checkFields(response.property_visit);
        });

    }

    checkFields = (reportDetails) =>{
        let isCoReport = reportDetails.inspection_type == "co"
        let validChecks = []
        this.setState({reportDetails:reportDetails})

        // TITLE IMAGE
        let titleValCheck= {"valid":true,"text":"Title Image","reasons":[]}
        if (!reportDetails.title_image) {
            titleValCheck["valid"] = false
            titleValCheck["reasons"].push("No Title Image Uploaded")
        }
        validChecks.push(titleValCheck)
        
        // CHECKLIST
        let checkListValCheck = {"valid":true,"text":"Checklist","reasons":[]}
        if(reportDetails.evidence_of_pets === null) {
            checkListValCheck["valid"] = false
            checkListValCheck["reasons"].push("Evidence of Pets options not selected")
        }
        if(reportDetails.evidence_of_pets === true && (reportDetails.evidence_of_pets_notes === null || reportDetails.evidence_of_pets_notes.trim() == "")) {
            checkListValCheck["valid"] = false
            checkListValCheck["reasons"].push("No notes given for presence of evidence of pets")
        }
        
        if(reportDetails.evidence_of_smoking === null) {
            checkListValCheck["valid"] = false
            checkListValCheck["reasons"].push("Evidence of Smoking options not selected")
        }
        if(reportDetails.evidence_of_smoking === true && (reportDetails.evidence_of_smoking_notes === null || reportDetails.evidence_of_smoking_notes.trim() == "")) {
            checkListValCheck["valid"] = false
            checkListValCheck["reasons"].push("No notes given for presence of evidence of smoking")
        }
        if(reportDetails.general_cleanliness === null || reportDetails.general_cleanliness.trim() == "" ) {
            checkListValCheck["valid"] = false
            checkListValCheck["reasons"].push("No General Cleanliness notes")
        }
        
        validChecks.push(checkListValCheck)
        
   
        //ALARMS
        let alarmValCheck= {"valid":true,"text":"Alarms","reasons":[]}
        if (reportDetails.property_visit_alarms.length > 0){

            let reasons = []
            reportDetails.property_visit_alarms.map((alarm, index)=>{
     
                    if (!alarm.file.url ) {
                        alarmValCheck["valid"] = false
                        alarmValCheck["reasons"].push(`Alarm ${index + 1} without Image`)
                    }
            })
        } else {
            alarmValCheck = {"valid":false,"text":"Alarms","reasons":["No Alarms Found"]}
        } 
        validChecks.push(alarmValCheck)

   
    // // ROOMS 
    let roomValCheck= {"valid":true,"text":"Rooms","reasons":[]}
        if (reportDetails.property_visit_rooms.length > 0){

            let reasons = []
            reportDetails.property_visit_rooms.map((room, index)=>{
     
                    if (!(room.property_visit_images.length > 0) ) {
                        roomValCheck["valid"] = false
                        roomValCheck["reasons"].push(`Room ${index + 1} without Images`)
                    }
            })
        } else {
            roomValCheck = {"valid":false,"text":"Rooms","reasons":["No Rooms Found"]}
        } 
        validChecks.push(roomValCheck)

    // Setstate
    this.setState({validChecks:validChecks})
}
    render() {
        return (<Segment>
            <Modal size="large" open={this.props.showChecklist} onClose={(e) => {
            }}><Modal.Header>Report Completion Checklist</Modal.Header>
            <Modal.Content style={{paddingTop: '0'}}>
                <div className="modal-close-button">
                    <Button basic icon negative onClick={(e) => {
                        this.props.handleClose();
                    }}><Icon name="close"/></Button>
                </div>
                    <Modal.Description>
                  <Segment>
                  {this.props.reportUpdates.rooms.length +this.props.reportUpdates.groups.length +this.props.reportUpdates.items.length > 0 &&<Message icon negative><Icon name='exclamation'  /><Message.Content><Message.Header>You have unsaved changes to the report</Message.Header>Please save your changes before completing the checklist</Message.Content></Message>}
  {!this.state.reportDetails &&   <Message icon>
    <Icon name='circle notched' loading />
    <Message.Content>
      <Message.Header>Loading Report Details</Message.Header>
    </Message.Content>
  </Message>}
  {this.props.reportDetails && this.state.reportDetails && <React.Fragment>
    <Segment>
    <Message
    header='A Final Check'
    content='Please try to address all points that have been flagged, as much as possible, before submitting the report.'
  />
        <Divider/>
        {this.props.userRole == "clerk" && <div style={{textAlign:"center"}}>
        <Button primary onClick={()=>{this.props.completeReport()}}>Submit Report</Button>
    </div>}
    </Segment>
        <Segment >
     {this.state.validChecks.map(checkObj =>{
        return <Message  negative={!checkObj["valid"]}positive={checkObj["valid"]}>
            <Message.Header><Icon name={checkObj["valid"]?'check':"exclamation"}  />{checkObj["text"]}</Message.Header>
            <Message.List>
                {checkObj["reasons"].map(reason =>{
                    return <Message.Item>{reason}</Message.Item>
                })}
            </Message.List>
        </Message> 
     })}

      </Segment>


    </React.Fragment>}
    
                </Segment>
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }

}

export default ReportContainer(PVChecklist);


// WEBPACK FOOTER //
// ./src/views/property_visits/pv_completion_checklist.js